//about
export const GET_SHORT_CATEGORY_LIST = "GET_SHORT_CATEGORY_LIST";
export const GET_ABOUT_LIST = "GET_ABOUT_LIST";
export const GET_FAQ = "GET_FAQ";

//promotions
export const GET_PROMOTIONS_LIST = "GET_PROMOTIONS_LIST";
export const GET_PROMOTIONS_CURRENT_LIST = "GET_PROMOTIONS_CURRENT_LIST";

//auth
export const GET_TOKEN = "GET_TOKEN";
export const GET_TOKEN_PHONE = "GET_TOKEN_PHONE";
export const LOGOUT = "LOGOUT";
export const REGISTRATION = "REGISTRATION";
export const SING_IN_WITH_GOOGLE = "SING_IN_WITH_GOOGLE";
export const SING_IN_WITH_FACEBOOK = "SING_IN_WITH_FACEBOOK";
export const SEND_CODE_PHONE = "SEND_CODE_PHONE";
export const RESTORE_PASSWORD = "RESTORE_PASSWORD";
export const SET_NEW_PASSWORD = "SET_NEW_PASSWORD";
export const LOGIN_BY_TOKEN = "LOGIN_BY_TOKEN";

//setting
export const GET_SEO_DATA = "GET_SEO_DATA";
export const GET_ALL_PAGES = "GET_ALL_PAGES";
export const GET_TRANSLATIONS = "GET_TRANSLATIONS";
export const GET_CATEGORIES_MENU = "GET_CATEGORIES_MENU";
export const GET_CATEGORY_FILTERS = "GET_CATEGORY_FILTERS";
export const GET_PRICE_FILTER = "GET_PRICE_FILTER";

//support
export const GET_SUPPORT_LIST = "GET_SUPPORT_LIST";
export const GET_COOKIE_AGREEMENT = "GET_COOKIE_AGREEMENT";

//search
export const GET_SEARCH_LIST = "GET_SEARCH_LIST";
export const GET_HEADER_SEARCH_TOOLTIP = "GET_HEADER_SEARCH_TOOLTIP";

//contacts
export const SEND_FEEDBACK = "SEND_FEEDBACK";
export const GET_CONTACTS = "GET_CONTACTS";

//faq

//home
export const GET_MAIN_SLIDER = "GET_MAIN_SLIDER";
export const GET_PRODUCTS_LIST = "GET_PRODUCTS_LIST";
export const GET_BANNER_LIST = "GET_BANNER_LIST";
export const GET_DISCOUNT_LIST = "GET_DISCOUNT_LIST";
export const GET_CLIENTS_SLIDER = "GET_CLIENTS_SLIDER";
export const GET_ARTICLES_LIST = "GET_ARTICLES_LIST";
export const GET_ARTICLES_ITEM = "GET_ARTICLES_ITEM";
export const GET_PRODUCTS_ITEM = "GET_PRODUCTS_ITEM";
export const GET_MOBILE_PRODUCTS_LIST = "GET_MOBILE_PRODUCTS_LIST";

//basket
export const GET_RECOMMENDED_LIST = "GET_RECOMMENDED_LIST";
export const CREATE_ORDER = "CREATE_ORDER";
export const GET_BASKET_LIST = "GET_BASKET_LIST";
export const ADD_PRODUCT_TO_BASKET = "ADD_PRODUCT_TO_BASKET";
export const REMOVE_PRODUCT_FROM_BASKET = "REMOVE_PRODUCT_FROM_BASKET";
export const SEND_BASKET = "SEND_BASKET";
export const GET_RESPONSE_ORDER = "GET_RESPONSE_ORDER";
export const SEND_PROMOCODE = "SEND_PROMOCODE";

//category
export const GET_CHILD_CATEGORY = "GET_CHILD_CATEGORY";
export const GET_FILTER_PRODUCTS_LIST = "GET_FILTER_PRODUCTS_LIST";
export const GET_FILTER_PRODUCTS_LIST_ALL = "GET_FILTER_PRODUCTS_LIST_ALL";
export const GET_ATTRIBUTES_PRODUCTS_LIST = "GET_ATTRIBUTES_PRODUCTS_LIST";
export const GET_ALL_PRODUCTS_LIST = "GET_ALL_PRODUCTS_LIST";
export const GET_ALL_PRODUCTS_LIST_WITH_ATTRIBUTES = "GET_ALL_PRODUCTS_LIST_WITH_ATTRIBUTES";
export const GET_ACTIVE_PRICE_FILTER = "GET_ACTIVE_PRICE_FILTER";

//card
export const GET_PRODUCT = "GET_PRODUCT";
export const GET_PROMO_LIST = "GET_PROMO_LIST";
export const GET_NEW_COLLECTION_LIST = "GET_NEW_COLLECTION_LIST";
export const GET_PRODUCT_REVIEWS = "GET_PRODUCT_REVIEWS";
export const SEND_REVIEW = "SEND_REVIEW";
export const FAST_BUY = "FAST_BUY";
export const ADD_CARD_PRODUCT_TO_BASKET = "ADD_CARD_PRODUCT_TO_BASKET";
export const GET_PROMOCODE = "GET_PROMOCODE";

//setting
export const FETCH_USER_DATA = "FETCH_USER_DATA";

//profile
export const UPDATE_USER_DATA = "UPDATE_USER_DATA";
export const UPDATE_USER_PASSWORD = "UPDATE_USER_PASSWORD";
export const GET_ACTIVE_ORDER_LIST = "GET_ACTIVE_ORDER_LIST";
export const GET_NEXT_ACTIVE_ORDER_LIST = "GET_NEXT_ACTIVE_ORDER_LIST";
export const GET_MORE_ACTIVE_ORDER_LIST = "GET_ACTIVE_ORDER_LIST";
export const GET_ARCHIVE_ORDER_LIST = "GET_ARCHIVE_ORDER_LIST";
export const GET_FAVOURITE_LIST = "GET_FAVOURITE_LIST";
export const ADD_USER_ADDRESS = "ADD_USER_ADDRESS";
export const REMOVE_USER_ADDRESS = "REMOVE_USER_ADDRESS";
export const EDIT_USER_ADDRESS = "EDIT_USER_ADDRESS";
export const ADD_USER_ICON = "ADD_USER_ICON";
export const LINK_WITH_GOOGLE = "LINK_WITH_GOOGLE";
export const LINK_WITH_FACEBOOK = "LINK_WITH_FACEBOOK";
export const UNLINK_WITH_GOOGLE = "UNLINK_WITH_GOOGLE";
export const UNLINK_WITH_FACEBOOK = "UNLINK_WITH_FACEBOOK";
export const GET_AGENT_MONEY = "GET_AGENT_MONEY";
export const ADD_NEW_AGENT_CLIENT = "ADD_NEW_AGENT_CLIENT";
export const GET_AGENT_CLIENTS = "GET_AGENT_CLIENTS";
export const REMOVE_AGENT_CLIENT = "REMOVE_AGENT_CLIENT";
export const EDIT_AGENT_CLIENT = "EDIT_AGENT_CLIENT";
export const DELETE_ORDER = "DELETE_ORDER";

//favorites
export const GET_FAVORITES_LIST = "GET_FAVORITES_LIST";
export const ADD_PRODUCT_TO_FAVORITE = "ADD_PRODUCT_TO_FAVORITE";
export const REMOVE_PRODUCT_IN_FAVORITE = "REMOVE_PRODUCT_IN_FAVORITE";

// payments-methods
export const GET_PAYMENT_METHODS_LIST = "GET_PAYMENT_METHODS_LIST";

// delivery-methods
export const GET_DELIVERY_METHODS_LIST = "GET_DELIVERY_METHODS_LIST";
export const GET_DELIVERY_FILIAL = "GET_DELIVERY_FILIAL";

// articles
export const GET_RANDOM_ARTICLES_LIST = "GET_RANDOM_ARTICLES_LIST";
export const GET_ARTICLES_LIST_CATEGORY = "GET_ARTICLES_LIST_CATEGORY";
export const GET_ARTICLES_CURRENT_CATEGORY = "GET_ARTICLES_CURRENT_CATEGORY";
export const SEND_DATA_FROM_POPUPS = "SEND_DATA_FROM_POPUPS";

//agent-info
export const GET_AGENT_INFO = "GET_AGENT_INFO";
export const GET_AGENT_INSTRUCTION = "GET_AGENT_INSTRUCTION";
export const REGISTRATION_AGENT = "REGISTRATION_AGENT";

// order
export const NOVA_POSHTA_GET_DEPARTMENS = "NOVA_POSHTA_GET_DEPARTMENS";
export const NOVA_POSHTA_GET_TOWNS = "NOVA_POSHTA_GET_TOWNS";
export const CREATE_INVOICE = "CREATE_INVOICE";
export const CREATE_TRANSACTION = "CREATE_TRANSACTION";
// export const CREATE_TRANSACTION ='CREATE_TRANSACTION'

//top products
export const GET_PRODUCTS_TOP_LIST = "GET_PRODUCTS_TOP_LIST";

//branches
export const GET_BRANCHES = "GET_BRANCHES";

// Robots
export const GET_ROBOTS = "GET_ROBOTS";
export const CHECK_ROBOTS = "CHECK_ROBOTS";
